import router from "@/router";

export const RaddarEvent = {
    Ping: 'ping',
    ShoppingList:{
        Add: 'shopping-list-add',
        Remove: 'shopping-list-remove',
        Quantity: 'shopping-list-qty',
        Clear: 'shopping-list-clear',
        List: 'shopping-list-list',
        GetList: 'shopping-list-getList'
    }
}

const getters = {
    isRaddar(state, getters, rootState, rootGetters) {
        if(rootGetters["config/features"]?.raddar?.force)return true;
        const fc = router.currentRoute.query?._fc;
        if(fc){
            return fc?.includes('raddar');
        }

        return false;
    }
}

export default {
    namespaced: true,
    getters
}
